import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import TableShows from "./TableShows";
import { toast } from "react-toastify";

export default function Shows() {
  const token = useSelector((state) => state.auth.token);

  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [loadingData, setLoadingData] = useState(false);
  const [loadingError, setLoadingError] = useState(null);
  const rowsPerPage = 10;

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };


  useEffect(() => {
    const fetchShowCase = async () => {
      setLoadingData(true);
      try {
        const response = await fetch(
            `${process.env.REACT_APP_API_URL}/api/v1/show_case/list?page=${page + 1}&limit=${rowsPerPage}`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
        );
        if (!response.ok) {
          const errorMessage = "Ошибка при загрузке данных";
          toast.error(errorMessage);
          setLoadingData(false);
          setLoadingError(errorMessage);
          return;
        }
        const result = await response.json();
        setData(result?.data || []);
        setTotal(result?.total || 0);
      } catch (error) {
        setLoadingError(`Ошибка: ${error.message}`);
      } finally {
        setLoadingData(false);
      }
    };

    fetchShowCase();
  }, [token, page, rowsPerPage]);


  if (loadingData) {
    return (
      <div className="loadingContainer">
        <div className="loader"></div>
      </div>
    );
  }
  if (loadingError) {
    return (
      <div className="errorDataBox">
        <p>{loadingError}</p>
      </div>
    );
  }
  return (
    <div className="container">
      <h1 className="title" style={{ marginBottom: 20 }}>
        Показы
      </h1>

      <TableShows
        shows={data}
        page={page}
        total={total}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
      />
    </div>
  );
}
